import { useEffect, useState } from 'react';
import { AccountsListActions } from './actions';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import {
    Account,
    AccountFilter,
} from '../../../../../shared/types/modules/account';
import { asyncGetAccounts } from '../../../../../services/accounts.service';
import { ISelect } from '../../../../../shared/types/shared';
import { useNavigate } from 'react-router-dom';
import { TableTooltip } from '../../../../components/general/table';
import DateTimeFormat from '../../../../components/dateTimeFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const useAccountsList = (filters?: AccountFilter) => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Account[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<AccountFilter>({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Account>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <AccountsListActions account={row.row} />,
        });
    }

    columns.push(
        {
            field: 'document',
            headerName: 'Identificación',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'name',
            headerName: 'Nombre / Razón social',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip value={`${row.row.name} ${row.row.lastName}`} />
            ),
        },
        {
            field: 'cellPhone',
            headerName: 'Celular',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'phone',
            headerName: 'Teléfono',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'email',
            headerName: 'E-mail',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'typePersonContact',
            headerName: 'Tipo de persona contacto',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => <>{(row.row.personType as ISelect)?.name}</>,
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 120,
            flex: 0.2,
            valueGetter: (params) => (params.row?.active ? 'Sí' : 'No'),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetAccounts(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        navigate,
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
